import { Observable } from 'rxjs';
import { Papa } from 'ngx-papaparse';
import * as i0 from "@angular/core";
import * as i1 from "ngx-papaparse";
export class ExportFieldConfig {
}
export class ExportService {
    constructor(papa) {
        this.papa = papa;
    }
    importCSV(csv) {
        return new Observable((observer) => {
            const { data, errors } = this.papa.parse(csv);
            if (errors.length) {
                observer.error(errors);
                observer.complete();
            }
            else {
                observer.next(data);
                observer.complete();
            }
        });
    }
    exportCSV(rows, columns, includeHeader = true) {
        const exportRows = [];
        // #TODO: [AC] - ngx-papaparse wrapper doesn't support explicit header columns, manually build rows[]
        // add header
        if (includeHeader) {
            exportRows.push(columns.map(c => c.label));
        }
        // add data rows
        rows.forEach((row) => {
            const dataRow = columns.map((col) => row[col.field]);
            exportRows.push(dataRow);
        });
        return new Observable((observer) => {
            const csv = this.papa.unparse(exportRows, { quotes: true, header: false });
            observer.next(csv);
            observer.complete();
        });
    }
}
ExportService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ExportService_Factory() { return new ExportService(i0.ɵɵinject(i1.Papa)); }, token: ExportService, providedIn: "root" });
